import React from 'react'
import { useSelector } from 'react-redux'
import { getBottomMenu } from 'src/store/data.store'
import { Menu } from 'components/PageElements/Menu/Menu'
import { MenuItem } from 'components/PageElements/Menu/MenuItem'
import { FooterBlocks } from './FooterBlocks'
import styles from './Footer.module.scss'

type FooterProps = {
  /** Hides the numbered blocks (the salon page) */
  noSeasons?: boolean,
}

export const Footer: React.FC<FooterProps> = (props) => {
  const { noSeasons } = props
  const menu = useSelector(getBottomMenu)
  const year = new Date().getFullYear()

  return (
    <div className={styles.container}>
      {!noSeasons && (
        <div className={styles.seasons}>
          <FooterBlocks />
        </div>
      )}
      <div className={styles.menu}>
        <Menu place={'footer'}>
          {menu.map((el, index) => <MenuItem key={index} item={el} />)}
        </Menu>
      </div>
      <div className={styles.copyright}>
        <div className={styles.copyrightText}>
          © <span>2007-{year}</span>
          <span> Сеть салонов маникюра и педикюра «Пальчики»</span>
        </div>
        <div className={styles.credentials}>
          ООО «УК «ПАЛЬЧИКИ»
          ИНН 7701734820
          ОГРН  1077758122210
          Адрес юридический: 105066 г. Москва, ул. Старая Басманная, д.25
          office@palchiki.com
        </div>
      </div>
    </div>
  )
}
